enum Routes {
  MAIN,
  CHANNEL_LIST,
  ZAPPER,
  DETAIL,
  PLAYER,
  CORNER,
}

export default Routes;
